var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 119",
    d: "M17.8748 15.0005C13.3746 12.0004 9.3667 13.7855 8.87479 19.0005C-2.12508 17.0004 -0.624366 5.50102 7.37356 3.50102C15.3715 1.50102 21.375 8 17.8748 15.0005Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 599",
    cx: 9.375,
    cy: 6,
    r: 1.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 600",
    cx: 4.375,
    cy: 9,
    r: 1.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 601",
    cx: 5.375,
    cy: 14,
    r: 1.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 120",
    d: "M18.8754 5C18.375 7.5 14.8748 8.5 13.8751 7.5C12.8755 6.5 12.9061 5.54873 14.3733 4.5C15.1288 3.2485 15.3425 2.50619 14.8733 1C18.1074 1.85431 19.3369 2.69447 18.8754 5Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4029",
    x: 13.6255,
    y: 7.59977,
    width: 2.53774,
    height: 12.6104,
    rx: 0.5,
    transform: "rotate(13.0162 13.6255 7.59977)",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryArt);
export default __webpack_public_path__ + "static/media/project-category-art.afa4a51e.svg";
export { ForwardRef as ReactComponent };